(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@pakhshkit-js/pakhshkit-js"));
	else if(typeof define === 'function' && define.amd)
		define("kava", ["pakhshkit-js"], factory);
	else if(typeof exports === 'object')
		exports["kava"] = factory(require("@pakhshkit-js/pakhshkit-js"));
	else
		root["VidiunPlayer"] = root["VidiunPlayer"] || {}, root["VidiunPlayer"]["plugins"] = root["VidiunPlayer"]["plugins"] || {}, root["VidiunPlayer"]["plugins"]["kava"] = factory(root["VidiunPlayer"]["core"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition


// WEBPACK FOOTER //
// kava/webpack/universalModuleDefinition